// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type NotificationIntegrationsQueryVariables = Types.Exact<{
  resourceId: Types.Scalars['String'];
  resourceType: Types.CloudResourceType;
}>;


export type NotificationIntegrationsQuery = (
  { __typename?: 'Query' }
  & { notificationIntegrations?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'NotificationIntegration' }
    & Pick<Types.NotificationIntegration, 'id' | 'transport' | 'config' | 'resourceId' | 'resourceType' | 'event'>
  )>>> }
);

export type UpsertNotificationIntegrationMutationVariables = Types.Exact<{
  integration: Types.NotificationUpsertInput;
}>;


export type UpsertNotificationIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { upsertNotificationIntegration?: Types.Maybe<(
    { __typename?: 'NotificationIntegration' }
    & Pick<Types.NotificationIntegration, 'id' | 'resourceId' | 'resourceType' | 'transport' | 'event' | 'config'>
  )> }
);

export type RemoveNotificationIntegrationMutationVariables = Types.Exact<{
  integrationId: Types.Scalars['ID'];
}>;


export type RemoveNotificationIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { removeNotificationIntegration?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);


export const NotificationIntegrationsDocument = gql`
    query NotificationIntegrations($resourceId: String!, $resourceType: CloudResourceType!) {
  notificationIntegrations(resourceId: $resourceId, resourceType: $resourceType) {
    id
    transport
    config
    resourceId
    resourceType
    event
  }
}
    `;

/**
 * __useNotificationIntegrationsQuery__
 *
 * To run a query within a React component, call `useNotificationIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationIntegrationsQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      resourceType: // value for 'resourceType'
 *   },
 * });
 */
export function useNotificationIntegrationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NotificationIntegrationsQuery, NotificationIntegrationsQueryVariables>) {
        return ApolloReactHooks.useQuery<NotificationIntegrationsQuery, NotificationIntegrationsQueryVariables>(NotificationIntegrationsDocument, baseOptions);
      }
export function useNotificationIntegrationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NotificationIntegrationsQuery, NotificationIntegrationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<NotificationIntegrationsQuery, NotificationIntegrationsQueryVariables>(NotificationIntegrationsDocument, baseOptions);
        }
export type NotificationIntegrationsQueryHookResult = ReturnType<typeof useNotificationIntegrationsQuery>;
export type NotificationIntegrationsLazyQueryHookResult = ReturnType<typeof useNotificationIntegrationsLazyQuery>;
export type NotificationIntegrationsQueryResult = ApolloReactCommon.QueryResult<NotificationIntegrationsQuery, NotificationIntegrationsQueryVariables>;
export const UpsertNotificationIntegrationDocument = gql`
    mutation UpsertNotificationIntegration($integration: NotificationUpsertInput!) {
  upsertNotificationIntegration(integration: $integration) {
    id
    resourceId
    resourceType
    transport
    event
    config
  }
}
    `;
export type UpsertNotificationIntegrationMutationFn = ApolloReactCommon.MutationFunction<UpsertNotificationIntegrationMutation, UpsertNotificationIntegrationMutationVariables>;

/**
 * __useUpsertNotificationIntegrationMutation__
 *
 * To run a mutation, you first call `useUpsertNotificationIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNotificationIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNotificationIntegrationMutation, { data, loading, error }] = useUpsertNotificationIntegrationMutation({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useUpsertNotificationIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertNotificationIntegrationMutation, UpsertNotificationIntegrationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpsertNotificationIntegrationMutation, UpsertNotificationIntegrationMutationVariables>(UpsertNotificationIntegrationDocument, baseOptions);
      }
export type UpsertNotificationIntegrationMutationHookResult = ReturnType<typeof useUpsertNotificationIntegrationMutation>;
export type UpsertNotificationIntegrationMutationResult = ApolloReactCommon.MutationResult<UpsertNotificationIntegrationMutation>;
export type UpsertNotificationIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertNotificationIntegrationMutation, UpsertNotificationIntegrationMutationVariables>;
export const RemoveNotificationIntegrationDocument = gql`
    mutation RemoveNotificationIntegration($integrationId: ID!) {
  removeNotificationIntegration(integrationId: $integrationId) {
    success
    message
  }
}
    `;
export type RemoveNotificationIntegrationMutationFn = ApolloReactCommon.MutationFunction<RemoveNotificationIntegrationMutation, RemoveNotificationIntegrationMutationVariables>;

/**
 * __useRemoveNotificationIntegrationMutation__
 *
 * To run a mutation, you first call `useRemoveNotificationIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNotificationIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNotificationIntegrationMutation, { data, loading, error }] = useRemoveNotificationIntegrationMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useRemoveNotificationIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveNotificationIntegrationMutation, RemoveNotificationIntegrationMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveNotificationIntegrationMutation, RemoveNotificationIntegrationMutationVariables>(RemoveNotificationIntegrationDocument, baseOptions);
      }
export type RemoveNotificationIntegrationMutationHookResult = ReturnType<typeof useRemoveNotificationIntegrationMutation>;
export type RemoveNotificationIntegrationMutationResult = ApolloReactCommon.MutationResult<RemoveNotificationIntegrationMutation>;
export type RemoveNotificationIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveNotificationIntegrationMutation, RemoveNotificationIntegrationMutationVariables>;
